import React from 'react';
import { ProductHero } from './components/ProductHero';
import { DescriptionSection } from './components/DescriptionSection';
import { IncludedSection } from './components/IncludedSection';
import { ForWhoSection } from './components/ForWhoSection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <main className="w-full min-h-screen font-lato bg-cream-50 overflow-x-hidden" data-id="element-0">
      <ProductHero data-id="element-1" />
      <DescriptionSection data-id="element-2" />
      <IncludedSection data-id="element-3" />
      <ForWhoSection data-id="element-4" />
      <FAQSection data-id="element-5" />
      <CTASection data-id="element-6" />
      <Footer data-id="element-7" />
    </main>;
}